import { useState, useEffect } from 'react';

const getWindowSize = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
};

const useWindowSize = () => {
    const initSize = getWindowSize();
    const [size, setSize] = useState(initSize);

    const handleResize = () => {
        const size = getWindowSize();
        setSize(() => size);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return size;
};

export default useWindowSize;
